class Visitors {
    constructor(httpMethods) {
        this.api = httpMethods;
        this.EP = {
            UPDATE_VISITOR: '/api/sites/:siteId/visitors/:visitorId',
            GET_VISITORS: '/api/sites/:siteId/visitors',
        };
    }

    updateVisitor(visitor){
        let url = this.EP.UPDATE_VISITOR;
        let data = {
            id: visitor.id,
            firstName: visitor.firstName,
            lastName: visitor.lastName,
            comment: visitor.comment
        }
        return this.api.put(url, data, {
            visitorId: visitor.id,
        });
    }

    getVisitors(params) {
        let url = this.EP.GET_VISITORS;
        if (params.query !== '') {
            url = url + '?' + params.query;
        }
        return this.api.get(url);
    }
}

export default Visitors;